import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';

import { PowerSettingsNew as SignoutIcon } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useAuth } from 'auth';

const StyledBackgroundDiv = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  backgroundImage: 'url("/images/connected_world.svg")',
  backgroundPositionX: 'right',
  backgroundPositionY: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  padding: theme.spacing(2),
}));

const Content = styled('div')(() => ({}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-secondary': {
    marginTop: '4px',
    color: theme.palette.text.secondary,
  },
}));

const SettingsMenu = ({ className }) => {
  const theme = useTheme();

  const { user, signOut } = useAuth();

  return (
    <Box sx={{ width: '350px', maxWidth: '100%' }} className={className}>
      <StyledBackgroundDiv>
        <Typography variant="h6">{user.displayName}</Typography>
        <Typography sx={{ color: theme.palette.text.secondary }} variant="body2">
          {user.email}
        </Typography>
      </StyledBackgroundDiv>
      <Content>
        <List sx={{ padding: 0 }} component="div">
          <Link to="#">
            <ListItem
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: theme.palette.background.default,
                },
              }}
              component="div"
              onClick={signOut}
            >
              <ListItemIcon
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, 0.03)',
                  width: 40,
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  marginRight: theme.spacing(2),
                }}
              >
                <SignoutIcon sx={{ width: 16, height: 16 }} />
              </ListItemIcon>
              <StyledListItemText primary="Sign Out" secondary="" />
            </ListItem>
            <Divider />
          </Link>
        </List>
      </Content>
    </Box>
  );
};

SettingsMenu.propTypes = {
  className: PropTypes.string,
};

SettingsMenu.defaultProps = {
  className: '',
};

export default SettingsMenu;
